// Tiny in-memory TTL cache for rarely-changing dropdown-style data (offices, departments,
// modules). Not for frequently-changing data (customers, invoices, dashboards) — that's the
// backend Redis cache's job; caching it here too would risk showing stale data client-side.
const store = new Map();

export function getOrFetch(key, ttlMs, fetchFn) {
	const cached = store.get(key);
	if (cached && cached.expiresAt > Date.now()) {
		return cached.promise;
	}
	const promise = fetchFn();
	store.set(key, { promise, expiresAt: Date.now() + ttlMs });
	promise.catch(() => store.delete(key));
	return promise;
}

export function invalidate(key) {
	store.delete(key);
}

export function clearCache() {
	store.clear();
}
